import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
export const useAcompanhamentosNavegacao = () => {
  const history = useHistory(); // Função para navegar para detalhes/edição (clique na linha)

  const handleRowClick = useCallback(row => {
    if (row && row.Id) {
      history.push(`/pages/acompanhamentos/detalhes/${row.Id}`);
    }
  }, [history]); // Função para navegar para criação

  const handleAdicionar = useCallback(() => {
    history.push('/pages/acompanhamentos/criar');
  }, [history]);
  return {
    handleRowClick,
    handleAdicionar
  };
};
